import type { FetchListParams } from 'Services/ServiceProviderManagement/types'

export enum SalesPointTabType {
  DETAILS = 'details',
  ALLOWED_API_CLIENTS = 'allowed_api_clients'
}

export interface SalesPointAddress {
  street_address?: string
  postal_code?: string
  city?: string
}

export interface SalesPoint {
  owner_client: string
  client_read: string[]
  client_write: string[]
  service_provider_id: string
  sales_point_id: string
  usage: SalesPointUsage
  start_date: Date
  active: boolean
  activity_end_date: Date | null
  external_identifier: string
  name: string
  s365t_account_id: string
  customer_reference_name: string
  business_id: string
  additional_info: string
  sales_allowed: boolean
  sales_not_allowed_date: Date | null
  sales_not_allowed_modifier: string
  hsl_sales_point: boolean
  billed_at_sales_point_level: boolean
  transfer_sales_to_financial_system: boolean
  phone: string
  address?: SalesPointAddress
  created_timestamp: Date
  last_modified_timestamp: Date
  modified_timestamp: string
  source: string
  pta: string
}

export enum SalesPointUsage {
  PROD = 'PROD',
  TEST = 'TEST'
}

export interface FetchSalesPointListParams extends FetchListParams {
  active?: boolean
  service_provider_id?: string
}
